import { AnyObject, TagKey, TagValue } from '@xbcb/shared-types';

export * from './eventPublisher';
export * from './validatePayload';
export * from './iotEventPayload';
export * from './snsEventPayload';
export * from './sendEmailPayload';
export * from './sendNotificationPayload';

export type MessageAttributesProps = {
  key: TagKey;
  value: TagValue;
};

export type ExternalSystemRecipientsGroup = {
  ids: string[]; // references of external systems that should receive the payload
  payload: AnyObject;
  messageAttributes?: MessageAttributesProps[];
};
